import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["taxDetails", "taxIcon", "dropdown"]

  toggleTaxDetails() {
    if (this.taxDetailsTarget.style.maxHeight) {
      this.taxDetailsTarget.style.maxHeight = null
      this.taxIconTarget.style.transform = 'rotate(0deg)'
    } else {
      this.taxDetailsTarget.style.maxHeight = this.taxDetailsTarget.scrollHeight + 'px'
      this.taxIconTarget.style.transform = 'rotate(180deg)'
    }
  }

  toggleLanguage() {
    if (this.dropdownTarget.style.display === 'none') {
      this.dropdownTarget.style.display = 'block'
    } else {
      this.dropdownTarget.style.display = 'none'
    }
  }
}